const creditArchivesMge = r => require.ensure([], () => r(require('@/page/creditArchivesMge/creditArchivesMge')), 'creditArchivesMge');
const badInfoHandle = r => require.ensure([], () => r(require('@/page/creditArchivesMge/creditArchivesNotice/badInfoHandle')), 'badInfoHandle');
const goodInfoHandle = r => require.ensure([], () => r(require('@/page/creditArchivesMge/creditArchivesNotice/goodInfoHandle')), 'goodInfoHandle');
const propertyCreditQuery = r => require.ensure([], () => r(require('@/page/creditArchivesMge/creditArchivesQuery/propertyCreditQuery')), 'propertyCreditQuery');
const projectCreditQuery = r => require.ensure([], () => r(require('@/page/creditArchivesMge/creditArchivesQuery/projectCreditQuery')), 'projectCreditQuery');

const addInformationDis = r => require.ensure([], () => r(require('@/page/creditArchivesMge/addInformationDis/addInformationDis')), 'addInformationDis');
const informationDisList = r => require.ensure([], () => r(require('@/page/creditArchivesMge/informationDisList/informationDisList')), 'informationDisList');
const informationDetail = r => require.ensure([], () => r(require('@/page/creditArchivesMge/informationDetail/informationDetail')), 'informationDetail');
const templateDetail = r => require.ensure([], () => r(require('@/page/creditArchivesMge/announceTemplate/templateDetail')), 'templateDetail');

const creditArchivesRouter = {
  path: '',
  component: creditArchivesMge,
  meta: {
    icon: 'organMge',
    right: [],
    isShowMenu: true,
    keepAlive:true,
  },
  name: '诚信档案管理',
  redirect: '/index',
  children: [{
      path: '/badInfoHandle',
      component: badInfoHandle,
      name: '不良信息公开',
      meta: {
        right: ['不良信息公开'],
        isShowMenu: true,
        keepAlive:true,
      }
    },
    {
      path: '/goodInfoHandle',
      component: goodInfoHandle,
      name: '良好信息公开',
      meta: {
        right: ['良好信息公开'],
        isShowMenu: true,
        keepAlive:true,
      }
    },
    {
      path: '/propertyCreditQuery',
      component: propertyCreditQuery,
      name: '物业企业诚信档案查询',
      meta: {
        right: ['物业企业诚信档案查询'],
        isShowMenu: true,
        keepAlive:true,
      }
    },
    {
      path: '/projectCreditQuery',
      component: projectCreditQuery,
      name: '项目负责人诚信档案查询',
      meta: {
        right: ['项目负责人诚信档案查询'],
        isShowMenu: true,
        keepAlive:true,
      }
    }, {
      path: '/addInformationDis',
      component: addInformationDis,
      name: '新增信息公开',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive:true,
      }
    }, {
      path: '/informationDisList',
      component: informationDisList,
      name: '信息公开查询',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive:true,
      }
    }, {
      path: '/informationDetail',
      component: informationDetail,
      name: '信息公开详情',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive: false,
      }
    }, {
      path: '/templateDetail',
      component: templateDetail,
      name: '信息公开详情',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive: false,
      }
    },
  ]
};

export default creditArchivesRouter;
